/**
 * Uygulamanın bilgi mimarisi (IA) — tek kaynak.
 *
 * Kenar çubuğu, üst şeritteki başlık ve ana sayfadaki modül kartları hepsi
 * burayı okur. Yeni bir ekran eklerken burayı ve `App.js`'teki route'u
 * güncelle.
 *
 * Gruplar `contants.js`'teki eski üst menüden devralındı (Dashboardlar,
 * Alarmlar, Üretim, Geçmiş, AI); rol filtresi de aynı mantığı korur, böylece
 * kimin neyi gördüğü DEĞİŞMEZ — yalnız sunum değişir.
 *
 * Alanlar:
 *   key    benzersiz id
 *   path   route (App.js ile birebir aynı olmalı)
 *   icon   kenar çubuğu / kart ikonu
 *   label  i18n anahtarı (kısa ad)
 *   desc   i18n anahtarı (ne işe yarar)
 *   title  ESKİ menüdeki başlık — rol filtresi bununla eşleşir
 */
import {
  AlertOutlined,
  AppstoreOutlined,
  BarsOutlined,
  BranchesOutlined,
  BulbOutlined,
  ClockCircleOutlined,
  CloudServerOutlined,
  ClusterOutlined,
  DatabaseOutlined,
  DeploymentUnitOutlined,
  ExperimentOutlined,
  FieldTimeOutlined,
  FundOutlined,
  HistoryOutlined,
  HomeOutlined,
  InboxOutlined,
  PieChartOutlined,
  QuestionCircleOutlined,
  ScheduleOutlined,
  TableOutlined,
  ToolOutlined,
  WarningOutlined,
} from "@ant-design/icons";

export const NAV_SECTIONS = [
  {
    key: "overview",
    label: "nav.groups.overview",
    desc: "nav.groups.overviewDesc",
    items: [
      {
        key: "home",
        path: "/home",
        icon: <HomeOutlined />,
        label: "nav.items.home",
        desc: "nav.desc.home",
        title: "__home__", // her rolde görünür
        exact: true,
      },
      {
        key: "dashboard",
        path: "/dashboard",
        icon: <FundOutlined />,
        label: "nav.items.dashboard",
        desc: "nav.desc.dashboard",
        title: "Dashboard",
      },
      {
        key: "pano",
        path: "/pano",
        icon: <PieChartOutlined />,
        label: "nav.items.pano",
        desc: "nav.desc.pano",
        // Rol süzgeci eski menü başlığıyla eşleşir: panoyu Dashboard'u
        // görebilen herkes görür.
        title: "Dashboard",
      },
    ],
  },
  {
    key: "shopfloor",
    label: "nav.groups.shopfloor",
    desc: "nav.groups.shopfloorDesc",
    items: [
      {
        key: "asma",
        path: "/asma",
        icon: <ClusterOutlined />,
        label: "nav.items.asma",
        desc: "nav.desc.asma",
        title: "Asma",
      },
      {
        key: "asma-spv",
        path: "/asma-spv",
        icon: <DeploymentUnitOutlined />,
        label: "nav.items.asmaSpv",
        desc: "nav.desc.asmaSpv",
        title: "Asma SPV",
      },
      {
        key: "toplama",
        path: "/toplama",
        icon: <InboxOutlined />,
        label: "nav.items.toplama",
        desc: "nav.desc.toplama",
        title: "Toplama",
      },
    ],
  },
  {
    key: "production",
    label: "nav.groups.production",
    desc: "nav.groups.productionDesc",
    items: [
      {
        key: "uretim",
        path: "/uretim",
        icon: <AppstoreOutlined />,
        label: "nav.items.uretim",
        desc: "nav.desc.uretim",
        title: "Üretim",
      },
      {
        key: "stok-yeterliligi",
        path: "/stok-yeterliligi",
        icon: <ClockCircleOutlined />,
        label: "nav.items.stockSufficiency",
        desc: "nav.desc.stockSufficiency",
        title: "Üretim",
      },
      {
        key: "ozet",
        path: "/ozet",
        icon: <TableOutlined />,
        label: "nav.items.summary",
        desc: "nav.desc.summary",
        // Plastik fabrikasındaki "Özet" ekranının karşılığı; Üretim'i gören
        // herkes görür.
        title: "Üretim",
      },
      {
        key: "rework-hurda",
        path: "/rework-hurda",
        icon: <ToolOutlined />,
        label: "nav.items.reworkHurda",
        desc: "nav.desc.reworkHurda",
        title: "Rework/Hurda",
      },
      {
        key: "stok-seviyeleri",
        path: "/stok-seviyeleri",
        icon: <DatabaseOutlined />,
        label: "nav.items.stockLevels",
        desc: "nav.desc.stockLevels",
        title: "Stok Seviyeleri",
      },
    ],
  },
  {
    key: "monitoring",
    label: "nav.groups.monitoring",
    desc: "nav.groups.monitoringDesc",
    items: [
      {
        key: "alarm",
        path: "/alarm",
        icon: <AlertOutlined />,
        label: "nav.items.alarm",
        desc: "nav.desc.alarm",
        title: "Alarm",
      },
      {
        key: "alarm2",
        path: "/alarm2",
        icon: <WarningOutlined />,
        label: "nav.items.alarm2",
        desc: "nav.desc.alarm2",
        title: "Alarm2",
      },
      {
        key: "status-info",
        path: "/status-info",
        icon: <BarsOutlined />,
        label: "nav.items.statusInfo",
        desc: "nav.desc.statusInfo",
        title: "Durum Bilgisi",
      },
    ],
  },
  {
    key: "planning",
    label: "nav.groups.planning",
    desc: "nav.groups.planningDesc",
    items: [
      {
        key: "vardiya-plani",
        path: "/konveyor",
        icon: <ScheduleOutlined />,
        label: "nav.items.shiftPlan",
        desc: "nav.desc.shiftPlan",
        title: "Vardiya Planı",
      },
      {
        key: "sap-siparisleri",
        path: "/sap-siparisleri",
        icon: <CloudServerOutlined />,
        label: "nav.items.sapOrders",
        desc: "nav.desc.sapOrders",
        // Plastik fabrikasındaki SAP ekranının karşılığı. Yönetim ve planlama
        // görür; saha rolleri (ps_govde, ps_boyahane) için HIDDEN_BY_ROLE'de gizli.
        title: "SAP Siparişleri",
      },
      {
        key: "constraints",
        path: "/constraints",
        icon: <BranchesOutlined />,
        label: "nav.items.constraints",
        desc: "nav.desc.constraints",
        title: "Canlı Kısıt",
        // App.js'te route var ama eski menüde yorum satırıydı; gizli tutuldu.
        hidden: true,
      },
    ],
  },
  {
    key: "history",
    label: "nav.groups.history",
    desc: "nav.groups.historyDesc",
    items: [
      {
        key: "kontrol-gecmisi",
        path: "/kontrol-gecmisi",
        icon: <HistoryOutlined />,
        label: "nav.items.controlHistory",
        desc: "nav.desc.controlHistory",
        title: "Kontrol Geçmişi",
      },
      {
        key: "ariza-gecmisi",
        path: "/ariza-gecmisi",
        icon: <FieldTimeOutlined />,
        label: "nav.items.failureHistory",
        desc: "nav.desc.failureHistory",
        title: "Arıza Geçmişi",
      },
      {
        key: "plc",
        path: "/plc",
        icon: <DatabaseOutlined />,
        label: "nav.items.plcData",
        desc: "nav.desc.plcData",
        title: "PLC verileri",
      },
    ],
  },
  {
    key: "ai",
    label: "nav.groups.ai",
    desc: "nav.groups.aiDesc",
    items: [
      {
        key: "ai-sonuclari",
        path: "/ai-sonuclari",
        icon: <ExperimentOutlined />,
        label: "nav.items.aiResults",
        desc: "nav.desc.aiResults",
        title: "AI Sonuçları",
      },
      {
        key: "ai-karsilastirma",
        path: "/ai-karsilastirma",
        icon: <BranchesOutlined />,
        label: "nav.items.aiComparison",
        desc: "nav.desc.aiComparison",
        title: "AI Karşılaştırma",
      },
    ],
  },
  {
    key: "other",
    label: "nav.groups.other",
    desc: "nav.groups.otherDesc",
    items: [
      {
        key: "beta-screen",
        // Yol DEĞİŞTİRİLMEZ: Constraints bileşenleri API isteklerine "/beta"
        // önekini tam olarak `pathname === "/simulasyon"` karşılaştırmasıyla
        // ekliyor. Burada yolu oynatmak simülasyon yazmalarını canlı uçlara
        // gönderirdi — değişen yalnız kenar çubuğundaki ad.
        path: "/simulasyon",
        icon: <BulbOutlined />,
        label: "nav.items.beta",
        desc: "nav.desc.beta",
        title: "Beta",
      },
      {
        key: "simulasyon",
        path: "/simulasyon-ekrani",
        icon: <ExperimentOutlined />,
        label: "nav.items.simulasyon",
        desc: "nav.desc.simulasyon",
        // Rol süzgeci başlıkla eşleşiyor. Ekran daha önce Beta sayfasının bir
        // sekmesiydi; "Beta" kalınca kimin göreceği değişmez.
        title: "Beta",
      },
      {
        key: "help-center",
        path: "/help-center",
        icon: <QuestionCircleOutlined />,
        label: "nav.items.help",
        desc: "nav.desc.help",
        title: "Yardım",
      },
    ],
  },
];

/**
 * Rol başına GİZLENEN başlıklar.
 *
 * Kaynak: eski `Components/Navbar.jsx` içindeki filtre. Aynı başlıklar aynı
 * roller için çıkarılıyor ki görünürlük davranışı bire bir korunsun.
 * `ps_admin` her şeyi görür.
 */
const HIDDEN_BY_ROLE = {
  ps_yonetim: [
    "Asma",
    "Toplama",
    "Rework/Hurda",
    "Stok Seviyeleri",
    "Alarm",
    "Alarm2",
    "Kontrol Geçmişi",
    "Arıza Geçmişi",
    "Yardım",
    "Beta",
  ],
  ps_planlama: ["Asma", "Toplama", "Alarm", "Alarm2", "Beta"],
  ps_govde: [
    "Asma SPV",
    "Toplama",
    "Rework/Hurda",
    "Stok Seviyeleri",
    "Alarm2",
    "Vardiya Planı",
    "SAP Siparişleri",
    "Beta",
  ],
  ps_boyahane: ["Asma", "Alarm", "SAP Siparişleri", "Beta"],
};

/** Rol sırası — eski Navbar'daki `switch(true)` sırasıyla aynı. */
const ROLE_ORDER = ["ps_yonetim", "ps_planlama", "ps_govde", "ps_boyahane"];

/**
 * Kullanıcının rollerine göre gezinme ağacını süzer.
 * Boş kalan gruplar düşer. Tanınmayan rol → boş liste (eski davranışta
 * `default: null` idi, yani menü hiç çizilmiyordu).
 */
export const filterNavForRoles = (roles = []) => {
  const has = (r) => roles?.includes(r);

  let hidden;
  if (has("ps_admin")) hidden = [];
  else {
    const role = ROLE_ORDER.find(has);
    if (!role) return [];
    hidden = HIDDEN_BY_ROLE[role] || [];
  }

  return NAV_SECTIONS.map((section) => ({
    ...section,
    items: section.items.filter(
      (item) => !item.hidden && !hidden.includes(item.title)
    ),
  })).filter((section) => section.items.length > 0);
};

/** Tüm öğeler (gizliler dahil) — başlık çözümlemesi için düz liste. */
export const ALL_NAV_ITEMS = NAV_SECTIONS.flatMap((section) =>
  section.items.map((item) => ({ ...item, section }))
);

/** `/scenario/:id` gibi parametreli yolları da eşleştirir. */
const matchPath = (pattern, pathname) => {
  if (pattern === pathname) return true;
  if (!pattern.includes(":")) return false;
  const p = pattern.split("/");
  const a = pathname.split("/");
  if (p.length !== a.length) return false;
  return p.every((seg, i) => seg.startsWith(":") || seg === a[i]);
};

/**
 * Aktif route'u bulur. Önce birebir, sonra parametreli eşleşme;
 * en uzun (en spesifik) yol kazanır.
 *
 * Not: yollar Türkçe karakter içerebilir. Tarayıcı `location.pathname`'i
 * yüzde kodlu verebildiği için karşılaştırmadan önce çözülür.
 */
export const findNavItem = (pathname) => {
  let p = pathname;
  try {
    p = decodeURIComponent(pathname);
  } catch {
    // Bozuk kodlama — ham hâliyle devam.
  }
  const exact = ALL_NAV_ITEMS.find((item) => item.path === p);
  if (exact) return exact;
  return (
    ALL_NAV_ITEMS.filter((item) => matchPath(item.path, p)).sort(
      (a, b) => b.path.length - a.path.length
    )[0] || null
  );
};

/** Kenar çubuğunda bir öğe aktif mi? */
export const isItemActive = (item, pathname) => {
  let p = pathname;
  try {
    p = decodeURIComponent(pathname);
  } catch {
    /* ham hâliyle devam */
  }
  return item.exact ? p === item.path : matchPath(item.path, p);
};
